import {AbstractTaskHandler} from "./AbstractTaskHandler";
import TakipXmlParser from "../../../takip_ac/TakipXmlParser";
import UyapTakipAc from "../../../takip_ac/UyapTakipAc";
import {TaskDurum} from "../../../enum/TaskDurum";
import {ITask} from "../GorevYoneticisiTypes";

export class UyapHizliTakipAcTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            console.log("UyapHizliTakipAcTaskHandler", task);
            let takip: UyapTakipAc = UyapTakipAc.fromJson(task.data);
            takip.parsedFile = TakipXmlParser.fromJson(task.data.parsedFile);
            console.log("UyapHizliTakipAcTaskHandler takipBaslat başladı");
            await takip.takipBaslat(false,true);
            console.log("UyapHizliTakipAcTaskHandler takipBaslat tamamlandı");
            task.response = takip;
            task.status = TaskDurum.BITTI_BASARILI;
            return task;
        } catch (e) {
            console.log(e);
            throw new Error(e.message)
        }
    }
    async webHandle(takip: UyapTakipAc): Promise<UyapTakipAc> { 
        try {
            await takip.tevziAl();
            await takip.takipAc(true);
            return takip;
        } catch (e) {
            throw new Error(e.message);
        }
    }
}